import React from "react";
import Container from "react-bootstrap/Container";

function About() {
    return (
        <Container>
            <h1>About</h1>
            <p>
                This is a Weather Application build on React. I have built this for our IOT Final project with the collaboration of other students.
            </p>
            <p>
                This is a simple React app that uses the{" "}
                <a href="https://reactjs.org/">React</a> library.

            </p>
            <p>
                The source code is available on{" "}
                <a href="https://github.com/Jaylapuck/IOT_Final_Project_Front_End.git" >GitHub</a>
            </p>
        </Container>
    );
}

export default About;

